import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const VisitTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page visit
    const trackVisit = async () => {
      try {
        await axios.post(`${API}/track-visit`, {
          path: location.pathname,
          timestamp: new Date().toISOString()
        }, { withCredentials: true });
      } catch (error) {
        // Silently fail - don't disrupt user experience
      }
    };

    trackVisit();
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default VisitTracker;
